module.exports = __webpack_public_path__ + "img/pcba_04@2x.7244bea2.png";